<app-block-ui
  [block]="blockUiService.isBlocked()"
  [blockMessage]="blockUiService.message()"
>
  <router-outlet />
  <div id="global-overlay-root"></div>
</app-block-ui>
